import React, { useMemo } from "react";
import SimpleTable from "../../../../../shared/components/common/ui/SimpleTable";

const ColumnSelectGrid = ({ rows, selectionModel, onSelectionChange, loadingColumns}) => {
  const columns = useMemo(
    () => [
      {
        field: "title",
        headerName: "Título",
        flex: 1,
      },
    ],
    []
  );

  return (
    <SimpleTable
      data={rows}
      columns={columns}
      mode="selection"
      loading={loadingColumns}
      selectionModel={selectionModel}
      onSelectionChange={onSelectionChange}
      hideHeaderActions
      hideFooter
    />
  );
};

export default ColumnSelectGrid;
